export const css = {
	oneaction: '_2_SjWYWk',
	' _key': 'afcpe-theme/afcpe/micro/quiz-widgets/flashcard'
};

export default css;
